'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchActiveQuotes = undefined;

var _immutable = require('immutable');

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * NOTE: This endpoint will hit Salesforce under the covers via a call to:
 * `quoteClient.getPendingApolloQuotesByHubId(hubId)`, only when there are valid
 * pending quotes for this hub. This endpoint should be hit sparingly as
 * our Salesforce API integration has rate limiting.
 *
 * Context: https://git.hubteam.com/HubSpotProtected/UpgradeCatalog/issues/230#issuecomment-464922
 *
 */

var fetchActiveQuotes = exports.fetchActiveQuotes = function fetchActiveQuotes() {
  var url = 'upgrade-catalog/v1/quotes/active';
  return _apiClient2.default.get(url).then(_immutable.fromJS);
};


//////////////////
// WEBPACK FOOTER
// ./js/api/QuoteApi.js
// module id = 730
// module chunks = 3 4